/** 独立站写死的导航槽位（文案与路由）；实例 ID 由启动查询填充 */
export const STANDALONE_PRODUCT_SLOTS = [
  {
    slotKey: "intel",
    routePath: "intel",
    label: "情报局",
    productKind: "intel",
  },
  {
    slotKey: "strategy",
    routePath: "strategy",
    label: "策略市场",
    productKind: "strategy_tool",
  },
  {
    slotKey: "institution",
    routePath: "institution",
    label: "机构在看",
    productKind: "inst_hotspot",
  },
  {
    slotKey: "concept",
    routePath: "concept",
    label: "概念库",
    productKind: "concept",
  },
  {
    slotKey: "holdings",
    routePath: "holdings",
    label: "我的持仓",
    productKind: "user_holdings",
  }
] as const;

export type StandaloneSlotKey = (typeof STANDALONE_PRODUCT_SLOTS)[number]["slotKey"];

export function slotKeyFromRoutePath(
  routePath: string | undefined
): StandaloneSlotKey | null {
  const seg = routePath?.trim() ?? "";
  const hit = STANDALONE_PRODUCT_SLOTS.find((s) => s.routePath === seg);
  return hit?.slotKey ?? null;
}
